export default __webpack_public_path__ + "static/media/4.dfe6f406.jpg";